import Vue from "vue";
import { ValidationRules } from "@/types/validation-rules";

const rules: ValidationRules = {
  required:
    (fieldName = "Campo") =>
    (v) =>
      !!v || `${fieldName} é obrigatório(a)`,

  minLength: (fieldName, min) => (v) =>
    !v ||
    v.length >= min ||
    `${fieldName} deve ter pelo menos ${min} caracteres`,

  maxLength: (fieldName, max) => (v) =>
    !v ||
    v.length <= max ||
    `${fieldName} deve ter no máximo ${max} caracteres`,
};

Vue.prototype.$rules = rules;
export default rules;
